/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunctionWithCategoriesAndControlsDto } from './FunctionWithCategoriesAndControlsDto';
import {
    FunctionWithCategoriesAndControlsDtoFromJSON,
    FunctionWithCategoriesAndControlsDtoFromJSONTyped,
    FunctionWithCategoriesAndControlsDtoToJSON,
    FunctionWithCategoriesAndControlsDtoToJSONTyped,
} from './FunctionWithCategoriesAndControlsDto';

/**
 * 
 * @export
 * @interface SspControlsGroupedResponse
 */
export interface SspControlsGroupedResponse {
    /**
     * 
     * @type {Array<FunctionWithCategoriesAndControlsDto>}
     * @memberof SspControlsGroupedResponse
     */
    data?: Array<FunctionWithCategoriesAndControlsDto>;
    /**
     * 
     * @type {number}
     * @memberof SspControlsGroupedResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof SspControlsGroupedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SspControlsGroupedResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SspControlsGroupedResponse interface.
 */
export function instanceOfSspControlsGroupedResponse(value: object): value is SspControlsGroupedResponse {
    return true;
}

export function SspControlsGroupedResponseFromJSON(json: any): SspControlsGroupedResponse {
    return SspControlsGroupedResponseFromJSONTyped(json, false);
}

export function SspControlsGroupedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SspControlsGroupedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FunctionWithCategoriesAndControlsDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SspControlsGroupedResponseToJSON(json: any): SspControlsGroupedResponse {
    return SspControlsGroupedResponseToJSONTyped(json, false);
}

export function SspControlsGroupedResponseToJSONTyped(value?: SspControlsGroupedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FunctionWithCategoriesAndControlsDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

